import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomersData, CustomersService }  from './Customers.service';


@Component({
  template: require('./CustomersDetails.component.html'),
  providers: [CustomersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomersDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objCustomers: CustomersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private CustomersService: CustomersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomers = new CustomersData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomersService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomersService.getByID(params['id']))
		.subscribe((item: CustomersData) => this.objCustomers = item);
		this.getLookups();
	}

	deleteCustomers(id: number) {
		if (window.confirm('Are you sure you want to delete this Customers?') == true)
		{
			this.CustomersService.deleteCustomers(this.objCustomers.CustomerID.toString())
			.subscribe(record => this.router.navigate(['/Customers']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('Customers record deleted successfully...'); }
			);
		}
	}
	gotoCustomersEdit() {
		this.router.navigate(['/Customers', this.objCustomers.CustomerID]);
	}

	gotoCustomers() {
		this.router.navigate(['/Customers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/CustomersDetails.component.ts